var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid content"},[_c('div',{staticClass:"h1 h-sakali mb-auto m-4 p-4 text-center"},[_vm._v("Sandkastenliga")]),_c('div',{staticClass:"text-center"},[_c('router-link',{staticClass:"btn btn-sakali",attrs:{"tag":"button","to":{name: 'login'}}},[_vm._v("Anmelden")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }